import stars from "assets/icons/ai-star.svg";
import React from "react";

export const StarsLogo = () => <img
  src={stars}
  alt="stars"
  color="white"
  style={{
    width: "20px",
    height: "20px"
  }}
/>;